<template>
  <div class="svg-icon" v-html="svg"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const icons = import.meta.glob('../assets/icons/*.svg', { query: '?raw', import: 'default', eager: true }) as Record<string, string>

const props = defineProps<{ icon: string }>()

const svg = computed(() => icons[`../assets/icons/${props.icon}.svg`] ?? '')
</script>

<style lang="scss">
.svg-icon {
  display: inline;

  > svg {
    fill: currentColor;
    height: 1em;
    width: 1em;
    vertical-align: -0.15em;
  }
}
</style>